import { render, staticRenderFns } from "./restaurantAttributes.vue?vue&type=template&id=d88dfd9e&scoped=true&"
import script from "./restaurantAttributes.vue?vue&type=script&lang=js&"
export * from "./restaurantAttributes.vue?vue&type=script&lang=js&"
import style0 from "./restaurantAttributes.vue?vue&type=style&index=0&id=d88dfd9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88dfd9e",
  null
  
)

export default component.exports